import { Children, isValidElement } from 'react';
import { isEmptyArrayOrObject } from '@philips-internal/oswald-ui-utils';
function isChildComponentType(child) {
    return 'type' in child && typeof child.type !== 'string';
}
function findChildWithPrettyValueFormatter(children) {
    if (!children || isEmptyArrayOrObject(children)) {
        return null;
    }
    const [firstChild] = Children.toArray(children).filter(isValidElement);
    if (!firstChild) {
        return null;
    }
    if (isChildComponentType(firstChild) && firstChild.type.formatPrettyValue) {
        return firstChild;
    }
    return findChildWithPrettyValueFormatter(firstChild.props.children);
}
export { findChildWithPrettyValueFormatter, };
//# sourceMappingURL=find-child-with-pretty-value-formatter.js.map